import * as React from "react";
import { IReport8Presenter } from "../../../presenter/report/Report8Presenter";
import { Divider, Typography, Icon } from "antd";
import Report8ParamsBox from "../../components/report/report8Components/Report8ParamsBox";
import PDFExportReport8 from "../../components/report/report8Components/PDFExportReport8";
import Report8Preview from "../../components/report/report8Components/Report8Preview";

export interface Props {}

export interface State extends IReport8Presenter {}

export default class Report8Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      report8ReportingPeriodList,
      onChangeReportingPeriod,
      report8CurrentReportingPeriod,
      translate,
      getPDFReport8,
      report8,
      report8SelectedApplicantIds,
      onApplicantSearch
    } = this.state;
    const _selectedApplicantsPath = report8SelectedApplicantIds
      ?.map(i => "&applicantIdsList=" + i)
      .join()
      .replace(",", "")
      .slice(1);
    return (
      <div className={"report-container"}>
        <Report8ParamsBox
          currentReportingPeriod={report8CurrentReportingPeriod}
          reportingPeriodList={report8ReportingPeriodList}
          onChangeReportingPeriod={onChangeReportingPeriod}
          getPDFReport={getPDFReport8}
          translate={translate}
          applicants={this.state.report8ApplicantList}
          loading={this.state.loaders.report8Loader}
          title={translate("reports.params.reporting_period")}
          onApplicantsChange={this.state.onApplicantsChange}
          selectedApplicantIds={report8SelectedApplicantIds}
          onApplicantSearch={onApplicantSearch}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        {report8 && (
          <div style={{ width: "75%", paddingLeft: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Typography.Title style={{ fontSize: 14 }}>
                {translate("reports.review_report")}
              </Typography.Title>
              <div>
                {!this.state.loaders.report8Loader && (
                  <PDFExportReport8
                    translate={translate}
                    data={this.state.report8}
                    title={report8CurrentReportingPeriod?.name}
                    subtitle={translate("reports.report_8")}
                    fileName={`${translate("reports.report_8")}.pdf`}
                  />
                )}
                <Divider
                  type={"vertical"}
                  style={{ fontSize: 10, height: "100%" }}
                />
                <a
                  key="file-excel"
                  href={`/api/reports/report8/reporting-periods/${report8CurrentReportingPeriod?.id}/xlsx/?${_selectedApplicantsPath}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon
                    type="file-excel"
                    theme={"outlined"}
                    style={{ fontSize: 20, color: "#20744B" }}
                  />
                </a>
              </div>
            </div>
            <Divider type={"horizontal"} />
            <Report8Preview
              translate={translate}
              data={report8}
              title={report8CurrentReportingPeriod?.name}
              subtitle={translate("reports.report_8")}
            />
          </div>
        )}
      </div>
    );
  }
}
